import React from 'react';
import PropTypes from 'prop-types';
import HomeIcon from '@material-ui/icons/Home';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PaymentIcon from '@material-ui/icons/Payment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';

// TODO: Get these from the server
const ICONS = {
  realAssets: HomeIcon,
  investable: TrendingUpIcon,
  cash: AttachMoneyIcon,
  creditCards: PaymentIcon,
  property: HomeIcon,
  otherLoans: AccountBalanceIcon,
};

const GroupIcon = ({ resource }) => {
  const icon = ICONS[resource.type()];
  const errorCount = resource.attr('errorCount');
  const warningCount = resource.attr('warningCount');

  const badgeProps = {};

  if (errorCount !== '0') {
    badgeProps.invisible = false;
    badgeProps.variant = 'standard';
    badgeProps.color = 'red';
    badgeProps.badgeContent = errorCount;
  } else if (warningCount !== '0') {
    badgeProps.invisible = false;
    badgeProps.variant = 'standard';
    badgeProps.color = 'orange';
    badgeProps.badgeContent = warningCount;
  }

  return (
    <Badge {...badgeProps}>
      <Icon icon={icon} />
    </Badge>
  );
};

GroupIcon.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default GroupIcon;
